
export default class EMFPath {
  constructor (name = '', label = '', num = 1, fontSize = 12, fontAngle = 0) {
    this.name = name;
    this.label = label;
    this.num = num;
    this.start_point = [0, 0];
    this.font_size = fontSize;
    this.font_angle = fontAngle;
    this.ex_path = [];
    this.in_paths = [];
    this.pocket = [];
    this.po_deepness = [];
  }

  setExPath (path) {
    this.ex_path = path;
  }

  addInPath (path) {
    this.in_paths.push(path);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/EMFPath.js